<template>
     <v-card>
         <v-toolbar
            flat
            dark
            color="primary"
        >
            <v-btn
              icon
              dark
              @click="$emit('fechar')"
            >
                <v-icon class="material-icons">
                    close
                </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-card-text v-if="frentista" class="headline text-xs-center">Solicitações</v-card-text>
        </v-toolbar>
        <v-container>
             <v-layout align-start justify-start row wrap fill-height v-if="solicitacoes">
                 <v-flex xs12>
                     <v-data-table
                        :headers="solicitacoesHeaders"
                        :items="solicitacoes"
                        hide-actions
                        class="elevation-1"
                    >
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.data }}</td>
                        <td>{{ props.item.valor }}</td>
                        <td>{{ props.item.aberto ? 'Não' : 'Sim' }}</td>
                        <td>{{ props.item.data_pagamento }}</td>
                    </template>
                    </v-data-table>
                 </v-flex>
             </v-layout>
        </v-container>
     </v-card>
</template>

<script>
export default {
  props: ['frentista', 'cnpj'],
  data () {
    return {
      solicitacoes: [],
      solicitacoesHeaders: [
        {
          text: 'Data realização',
          align: 'left',
          sortable: false,
          value: 'Data realização'
        },
        { text: 'Valor', sortable: false, value: 'Valor', align: 'center' },
        { text: 'Pago', sortable: false, value: 'Pago' },
        { text: 'Data pagamento', sortable: false, value: 'Data pagamento', align: 'center' }
      ]
    }
  },
  methods: {
    listarSolicitacoes () {
      this.$store.dispatch('getSolicitacoes', { 'cnpj': this.cnpj, 'id': this.frentista.id_frentista }).then(value => {
        this.solicitacoes = value
      })
    }
  },
  mounted () {
    if (this.frentista && this.cnpj) {
      this.listarSolicitacoes()
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>
